export default {
	middleware: {
		url: "https://api.leisuresportsinc.com/v4/"
		// url: "https://lsi-test-api.10uplabs.com/v3"
		//url: "https://x7teesowmg.execute-api.us-west-1.amazonaws.com/v2/",
		//url: "https://viyvdb6vwg.execute-api.us-east-1.amazonaws.com/dev", 10up's AWS
		//url: "http://localhost:3000"
	}
};



// WEBPACK FOOTER //
// ./src/config/config.js